export const USER_LOADED = "USER_LOADED";
export const AUTH_OK = "AUTH_OK";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

//Menu
export const GET_MENU = "GET_MENU";
export const MENU_ERROR = "MENU_ERROR";

//PopUp
export const SET_POPUP = "SET_POPUP";